module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// /app/~/stream-browserify/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 79
// module chunks = 0